<ng-container *transloco="let convert;">
  @if (!loading) {
    <div [id]="'history_overview_' + index" class="reply__inner">
      @if (questionHistory$ | async; as questionHistory) {
        <div class="question-chain">
          @for (question of questionHistory; track question; let i = $index) {
            @if (!question.withdrawnByUuid && question.answeredDate) {
              <div class="question-reply">
                <div
                  class="question-chain__date"
            [ngClass]="{
              'd-none':
                i !== 0 &&
                (localizeDate(question.answeredDate)) === (localizeDate(questionHistory[i - 1].askedDate))
            }"
                  >
                  <span class="question-chain__date-text">{{ localizeDate(question.answeredDate) }}</span>
                </div>
                <div class="history-inner history-inner--even">
                  <div class="history-inner__main">
                    @if (showUserName) {
                      <div class="history-label">{{ question.answeredBy != null ? convert('sellModule.question.questionDrawer.viewHistory.textSeller') + question.answeredBy : convert('sellModule.question.questionDrawer.viewHistory.labelSeller') }}</div>
                    } @else {
                      <div class="history-label">{{convert('sellModule.question.questionDrawer.viewHistory.labelSeller')}}</div>
                    }
                    <ng-template #answeredBy>
                      <div class="history-label">{{convert('sellModule.question.questionDrawer.viewHistory.labelSeller')}}</div>
                    </ng-template>
                    <div [id]="'history_dealer_answer_' + index + i" class="history-question">{{ question.answer }}</div>
                  </div>
                  <div [id]="'history_dealer_answer_date_time_' + index + i" class="history-inner__timestamp">
                    {{ localizeTime(question.answeredDate) }}
                  </div>
                </div>
              </div>
            }
            <div class="question-answer">
              <div
                class="question-chain__date"
            [ngClass]="{
              'd-none': (localizeDate(question.answeredDate)) === (localizeDate(question.askedDate))
            }"
                >
                <span class="question-chain__date-text">{{ localizeDate(question.askedDate) }}</span>
              </div>
              <div class="history-inner history-inner--odd">
                <div class="history-inner__main">
                  @if (showUserName) {
                    <div class="history-label">{{ question.askedBy != null ? convert('sellModule.question.questionDrawer.viewHistory.textBuyer') + question.askedBy : convert('sellModule.question.questionDrawer.viewHistory.labelBuyer') }}</div>
                  } @else {
                    <div class="history-label">{{convert('sellModule.question.questionDrawer.viewHistory.labelBuyer')}}</div>
                  }
                  <ng-template #askedBy>
                    <div class="history-label">{{convert('sellModule.question.questionDrawer.viewHistory.labelBuyer')}}</div>
                  </ng-template>
                  <div class="history-question">
                    <p
                      [id]="'history_dealer_question_' + index + i"
                      class="d-inline-block"
                      [ngClass]="{ withDrawnQuestion: question.withdrawnByUuid }"
                      >
                      {{ question.question }}
                    </p>
                    @if (question.withdrawnByUuid) {
                      <span class="ms-2 withDrawnQuestion__indicator"
                        ><i>(Withdrawn)</i></span
                        >
                      }
                    </div>
                  </div>
                  <div [id]="'history_dealer_question_date_time_' + index + i" class="history-inner__timestamp">
                    {{ localizeTime(question.askedDate) }}
                  </div>
                </div>
              </div>
            }
          </div>
        }
      </div>
    }
  </ng-container>
